// extracted by mini-css-extract-plugin
export default {"trigger":"Hamburger-module--trigger--aef7f","fakeActive":"Hamburger-module--fakeActive--f7116"};